<template>
    <div class="positionR">
        <div class="header" :style="{ background: color }"
            :class="$iosHeight()">
            <div class="head" :class="{'borderBot borderBotLeft0': !cancleLine}">
                <div class="headLeft" >
                    <div class="img" @click="onBack" v-if="!headL">
                        <img src="../../assets/img/b2b/icon_back_white@2x.png" alt="" v-if='iconColor'>
                        <img src="../../assets/img/b2b/navbar_icon_mune@2x.png" alt="" v-else>
                    </div>
                </div>
                <div class="headCenter" v-text="title" :style="{ color: iconColor }"></div>
                <div class="headRight" v-if="!icon"><span v-text="titleRight" @click="onSubmit"></span></div>
                <div class="headRight" v-if="icon">
                    <div class="img" @click="onSubmit">
                        <slot name="headRight">
                            <img src="../../assets/img/b2b/icon_search@2x.png" alt="">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="heightDiv" :class="$iosHeightDiv()"></div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    name: 'topHeader',
    props: ['title', 'titleRight', 'icon', 'headL', 'hosjoy_choose', 'color', 'iconColor', 'cancleLine', 'share'],
    data () {
        return {
            height: ''
        }
    },
    computed: {
        ...mapState({
            getUserInfo: state => state.b2b.userInfo
        })
    },
    methods: {
        onBack () {
            this.$emit('backPage')
        },
        onSubmit () {
            this.$emit('submit')
        },
        onChoose () {
            this.$emit('choose')
        }
    },
    mounted () {
        let iosHeight = localStorage.getItem('height')
        if (parseInt(iosHeight) === 64) {
            this.height = 'isIos'
        } else if (parseInt(iosHeight) === 88) {
            this.height = 'isIos2'
        }
    }
}
</script>
<style lang="scss" scoped>
    .header{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        width: 100%;
        // height: 88px;
        line-height: 88px;
        z-index: 99;
        background: #ffffff;
        transform: translateZ(0);
        -webkit-transform: translateZ(0);
        .head{
            display: flex;
            justify-content: space-between;
        }
        .headLeft{
            flex: 0 0 200px;
            .img{
                width: 88px;
                height: 88px;
            }
        }
        .headCenter{
            font-size: 36px;
            text-align: center;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        .headRight{
            flex: 0 0 200px;
            text-align: right;
            .img{
                width: 88px;
                height: 88px;
                float: right;
                padding-right: 5px;
            }
            span{
                font-size: 32px;
                color: #FF7A45;
                padding-right: 30px;
            }
        }
    }
    .positionR{
        position: relative;
        &.borderBot:before{
            z-index: 9999;
        }
    }
    .isAndroid {
        height: 88px;
    }
</style>
